import React from "react";
import HeroPhoneMockup from "@/components/HeroPhoneMockup";

/**
 * BrandPhoneCapture
 *
 * Hidden capture page used to render the rotating phone mockup against a
 * clean cream background for screen-grab → video pipeline (see
 * `/app/scripts/build_brand_phone_gif.py`).
 *
 * Not linked from anywhere in the public UI. Reachable only by typing the
 * URL `/brand/phone` directly.
 */
export default function BrandPhoneCapture() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#FAF9F6]"
      data-testid="brand-phone-capture"
    >
      <div style={{ transform: "scale(1.4)", transformOrigin: "center" }}>
        <HeroPhoneMockup />
      </div>
    </div>
  );
}
